import { AppHeaderNames } from '../typegen/app-header-names';

export class ClientAppHeaderNames extends AppHeaderNames {
	static readonly apiCallType: string = 'X-Call-Type';
}
